import en from "../../i18n/en";
import pl from "../../i18n/pl";

// ==================== Шаблоны визуализации ====================

export function getVisualizationTemplates(lang) {
  const t = lang === "pl" ? pl : en;

  return {
    instagram_posts: {
      title: t.visualizationTemplate.instagramPost,
      aiVariables: [
        { key: "USERNAME", label: t.visualizationTemplate.usernameInstagramPost, getValue: (result) => result.raw_data?.profile_info?.username || result.raw_data?.username || "N/A" },
        { key: "TEXT", label: t.visualizationTemplate.textInstagramPost, getValue: (result) => result.raw_data?.text || "N/A" },
        { key: "LIKES", label: t.visualizationTemplate.likes, getValue: (result) => String(result.raw_data?.likes || 0) },
        { key: "COMMENTS", label: t.visualizationTemplate.comments, getValue: (result) => String(result.raw_data?.comments || 0) },
        
      ],
      basicFilters : [

         { key: "USERNAME", label: t.visualizationTemplate.usernameInstagramPost, type: "text" },
        { key: "TEXT", label: t.visualizationTemplate.textInstagramPost,   type: "text"   },
        { key: "LIKES", label: t.visualizationTemplate.likes, type: "number"   },
        { key: "COMMENTS", label: t.visualizationTemplate.comments, type: "number"   },
        

        
      ],

  

      sections: [



        { type: "text", key: "text", label: t.visualizationTemplate.caption, getValue: (result) => result.raw_data?.text, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap", maxHeight: 300, overflowY: "auto" } },
        { type: "image", key: "image_url", label: t.visualizationTemplate.postImage, getValue: (result) => result.raw_data?.image_url, style: { maxHeight: 400, objectFit: "contain", borderRadius: 12, background: "#000" } },
        { type: "stats", label: t.visualizationTemplate.engagement, items: [
          { key: "likes", label: t.visualizationTemplate.likes, getValue: (result) => result.raw_data?.likes?.toLocaleString() || "0", icon: "❤️" },
          { key: "comments", label: t.visualizationTemplate.comments, getValue: (result) => result.raw_data?.comments?.toLocaleString() || "0", icon: "💬" },
        ]},
        { type: "author_link", label: t.visualizationTemplate.author, getValue: (result) => {
          const username = result.raw_data?.profile_info?.username || result.raw_data?.username;
          if (!username) return null;
          return { username: `@${username}`, url: `https://instagram.com/${username}`, icon: "👤" };
        }},
        { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => result.source },
        { type: "meta", label: t.visualizationTemplate.postInfo, items: [
          { key: "url", label: t.visualizationTemplate.postUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
          { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
        ]}
      ]
    },

    instagram_pages: {
      title: t.visualizationTemplate.instagramPage,
      aiVariables: [
        { key: "USERNAME", label: t.visualizationTemplate.instagram_profile_username, getValue: (result) => result.raw_data?.username || "N/A" },
        { key: "BIO", label: t.visualizationTemplate.instagram_profile_bio, getValue: (result) => result.raw_data?.bio || "N/A" },
        { key: "FOLLOWERS", label: t.visualizationTemplate.instagram_profile_followers, getValue: (result) => String(result.raw_data?.followers || "N/A") },
        { key: "FOLLOWING", label: t.visualizationTemplate.instagram_profile_following, getValue: (result) => String(result.raw_data?.followees || "N/A") },
        { key: "MEDIACOUNT", label: t.visualizationTemplate.instagram_profile_posts, getValue: (result) => String(result.raw_data?.mediacount || "N/A") },
        { key: "FULLNAME", label: t.visualizationTemplate.instagram_profile_fullname, getValue: (result) => String(result.raw_data?.full_name || "N/A") },
        
      ],
      basicFilters : [

         { key: "USERNAME", label: t.visualizationTemplate.instagram_profile_username, type: "text" },
        { key: "BIO",   label: t.visualizationTemplate.instagram_profile_bio, type: "text"   },
        { key: "FOLLOWERS", label: t.visualizationTemplate.instagram_profile_followers, type: "number"   },
        { key: "FOLLOWING", label: t.visualizationTemplate.instagram_profile_following, type: "number"   },
        { key: "MEDIACOUNT", label: t.visualizationTemplate.instagram_profile_posts,  type: "number"  },
        
      ],

      sections: [



        { type: "text", key: "bio", label: t.visualizationTemplate.bio, getValue: (result) => result.raw_data?.bio, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap" } },
        { type: "profile_header", label: t.visualizationTemplate.profile, getValue: (result) => {
          const username = result.raw_data?.username;
          return { username, url: `https://instagram.com/${username}`, full_name: result.raw_data?.full_name, profile_pic_url: result.raw_data?.profile_pic_url };
        }},
        { type: "stats", label: t.visualizationTemplate.pageStats, items: [
          { key: "followers", label: t.visualizationTemplate.followers, getValue: (result) => result.raw_data?.followers?.toLocaleString() || "N/A", icon: "👥" },
          { key: "following", label: t.visualizationTemplate.following, getValue: (result) => result.raw_data?.followees?.toLocaleString() || "N/A", icon: "👣" },
          { key: "posts", label: t.visualizationTemplate.posts, getValue: (result) => result.raw_data?.mediacount?.toLocaleString() || "N/A", icon: "📝" },
        ]},
        { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => result.source },
        { type: "meta", label: t.visualizationTemplate.details, items: [
          { key: "url", label: t.visualizationTemplate.pageUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
          { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
        ]}
      ]
    },

    facebook_posts: {
      title: t.visualizationTemplate.facebookPost,
      aiVariables: [
        { key: "TEXT", label: t.visualizationTemplate.facebook_post_text, getValue: (result) => result.raw_data?.description || result.raw_data?.text || "N/A" },
        { key: "LIKES", label: t.visualizationTemplate.likes, getValue: (result) => String(result.raw_data?.likes || 0) },
        { key: "COMMENTS", label: t.visualizationTemplate.comments, getValue: (result) => String(result.raw_data?.comments || 0) },
        
      ],
      basicFilters: [
        { key: "TEXT", label: t.visualizationTemplate.facebook_post_text, type: "text"  },
        { key: "LIKES", label: t.visualizationTemplate.likes,  type: "number" },
        { key: "COMMENTS", label: t.visualizationTemplate.comments,  type: "number" },
      
      ],
      
      sections: [


        { type: "text", key: "description", label: t.visualizationTemplate.postContent, getValue: (result) => result.raw_data?.description || result.raw_data?.text, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap", maxHeight: 300, overflowY: "auto" } },
        { type: "image", key: "image_url", label: t.visualizationTemplate.postImage, getValue: (result) => result.raw_data?.image_url, style: { maxHeight: 400, objectFit: "contain", borderRadius: 12, background: "#000" } },
        { type: "stats", label: t.visualizationTemplate.engagement, items: [
          { key: "likes", label: t.visualizationTemplate.likes, getValue: (result) => result.raw_data?.likes?.toLocaleString() || "0", icon: "👍" },
          { key: "comments", label: t.visualizationTemplate.comments, getValue: (result) => result.raw_data?.comments?.toLocaleString() || "0", icon: "💬" },
        ]},
        { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => { const s = result.source; if (!s) return null; return { ...s, keyword: s.keyword, scraped_url: s.scraped_url }; } },
        { type: "meta", label: t.visualizationTemplate.postInfo, items: [
          { key: "url", label: t.visualizationTemplate.postUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
          { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
        ]}
      ]
    },

    linkedin_posts: {
      title: t.visualizationTemplate.linkedinPost,
      aiVariables: [
        { key: "AUTHOR", label: t.visualizationTemplate.linkedin_post_author, getValue: (result) => result.raw_data?.post?.author?.name || "N/A" },
        { key: "HEADLINE", label: t.visualizationTemplate.linkedin_post_headline, getValue: (result) => result.raw_data?.post?.headline || "N/A" },
        { key: "TEXT", label: t.visualizationTemplate.linkedin_post_content, getValue: (result) => result.raw_data?.post?.articleBody || "N/A" },
        { key: "LIKES", label: t.visualizationTemplate.likes, getValue: (result) => String(result.raw_data?.post?.engagement?.likes || 0) },
        { key: "COMMENTS", label: t.visualizationTemplate.comments, getValue: (result) => String(result.raw_data?.post?.engagement?.comments || 0) },
        { key: "SHARES", label: t.visualizationTemplate.linkedin_post_shares, getValue: (result) => String(result.raw_data?.post?.engagement?.shares || 0) },
      ],

      basicFilters: [
        { key: "AUTHOR", label: t.visualizationTemplate.linkedin_post_author,  type:"text" },
        { key: "HEADLINE", label: t.visualizationTemplate.linkedin_post_headline,  type:"text"   },
        { key: "TEXT", label: t.visualizationTemplate.linkedin_post_content,  type:"text"   },
        { key: "LIKES", label: t.visualizationTemplate.likes, type:"number"   },
        { key: "COMMENTS", label: t.visualizationTemplate.comments,  type:"number" },
        { key: "SHARES", label: t.visualizationTemplate.linkedin_post_shares,  type:"number"},
      ],


      sections: [
        

        { type: "text", key: "headline", label: t.visualizationTemplate.headline, getValue: (result) => result.raw_data?.post?.headline, style: { fontSize: 16, fontWeight: 600, lineHeight: 1.4, marginBottom: 8 } },
        { type: "text", key: "articleBody", label: t.visualizationTemplate.postContent, getValue: (result) => result.raw_data?.post?.articleBody, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap", maxHeight: 300, overflowY: "auto" } },
        { type: "image", key: "image", label: t.visualizationTemplate.postImage, getValue: (result) => result.raw_data?.post?.image, style: { maxHeight: 400, objectFit: "contain", borderRadius: 12, background: "#000" } },
        { type: "profile_header", label: t.visualizationTemplate.author, getValue: (result) => {
          const author = result.raw_data?.post?.author;
          if (!author) return null;
          return { username: author.name, url: author.url, full_name: author.name, profile_pic_url: author.profileImage, subtitle: author.followers ? `${author.followers.toLocaleString()} ${t.visualizationTemplate.followers}` : null };
        }},
        { type: "stats", label: t.visualizationTemplate.engagement, items: [
          { key: "likes", label: t.visualizationTemplate.likes, getValue: (result) => result.raw_data?.post?.engagement?.likes?.toLocaleString() || "0", icon: "👍" },
          { key: "comments", label: t.visualizationTemplate.comments, getValue: (result) => result.raw_data?.post?.engagement?.comments?.toLocaleString() || "0", icon: "💬" },
          { key: "shares", label: t.visualizationTemplate.shares, getValue: (result) => result.raw_data?.post?.engagement?.shares?.toLocaleString() || "0", icon: "🔄" },
        ]},
        { type: "meta", label: t.visualizationTemplate.published, items: [
          { key: "datePublished", label: t.visualizationTemplate.date, getValue: (result) => result.raw_data?.post?.datePublished ? formatDate(result.raw_data.post.datePublished) : null, icon: "📅" },
        ]},
        { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => { const s = result.source; if (!s) return null; return { ...s, keyword: s.keyword, scraped_url: s.scraped_url }; } },
        { type: "meta", label: t.visualizationTemplate.postInfo, items: [
          { key: "url", label: t.visualizationTemplate.postUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
          { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
        ]}
      ]
    },

    facebook_pages: {
      title: t.visualizationTemplate.facebookPage,
      aiVariables: [
        { key: "NAME", label: t.visualizationTemplate.facebook_page_name, getValue: (result) => result.raw_data?.name || "N/A" },
        { key: "STATUS", label: t.visualizationTemplate.facebook_page_description, getValue: (result) => result.raw_data?.status || t.visualizationTemplate.noDescription },
       
        { key: "FOLLOWERS", label: t.visualizationTemplate.followers, getValue: (result) => String(result.raw_data?.followers || "N/A") },
        { key: "FOLLOWING", label: t.visualizationTemplate.following, getValue: (result) => String(result.raw_data?.following || "N/A") },
        { key: "EMAIL", label: t.visualizationTemplate.email, getValue: (result) => result.raw_data?.contact_info?.email || "N/A" },
        { key: "PHONE", label: t.visualizationTemplate.phone, getValue: (result) => result.raw_data?.contact_info?.phone || "N/A" },
        { key: "WEBSITE", label: t.visualizationTemplate.website, getValue: (result) => result.raw_data?.contact_info?.website || "N/A" },
        
      ],
      basicFilters: [
          { key: "NAME", label: t.visualizationTemplate.facebook_page_name,  type:"text" },
        { key: "STATUS", label: t.visualizationTemplate.facebook_page_description, type:"text"  },
       
        { key: "FOLLOWERS", label: t.visualizationTemplate.followers, type:"number" },
        { key: "FOLLOWING", label: t.visualizationTemplate.following,  type:"number" },
        { key: "EMAIL", label: t.visualizationTemplate.email, type:"text"  },
        { key: "PHONE", label: t.visualizationTemplate.phone, type:"text"  },
        { key: "WEBSITE", label: t.visualizationTemplate.website,  type:"text"  },
        { key: "HAS_PHONE", label: t.visualizationTemplate.hasPhone, type:"bool"  },
        { key: "HAS_EMAIL", label: t.visualizationTemplate.hasEmail, type:"bool"  },
      ],
      sections: [
        

        { type: "text", key: "status", label: t.visualizationTemplate.description, getValue: (result) => result.raw_data?.status || null, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap" } },
        { type: "profile_header", label: t.visualizationTemplate.profile, getValue: (result) => {
          const name = result.raw_data?.name;
          if (!name) return null;
          return { username: name, url: result.url || result.raw_data?.profile_url, full_name: name, profile_pic_url: result.raw_data?.avatar_url };
        }},
        { type: "text", key: "category", label: t.visualizationTemplate.category, getValue: (result) => result.raw_data?.category },
        { type: "stats", label: t.visualizationTemplate.pageStats, items: [
          { key: "followers", label: t.visualizationTemplate.followers, getValue: (result) => result.raw_data?.followers?.toLocaleString() || "0", icon: "👥" },
          { key: "following", label: t.visualizationTemplate.following, getValue: (result) => result.raw_data?.following?.toLocaleString() || "0", icon: "👣" },
        ]},
        { type: "meta", label: t.visualizationTemplate.contactInfo, items: [
          { key: "phone", label: t.visualizationTemplate.phone, getValue: (result) => result.raw_data?.contact_info?.phone, icon: "📞" },
          { key: "email", label: t.visualizationTemplate.email, getValue: (result) => result.raw_data?.contact_info?.email, icon: "✉️" },
          { key: "website", label: t.visualizationTemplate.website, getValue: (result) => result.raw_data?.contact_info?.website, isLink: true, icon: "🌐" },
          { key: "address", label: t.visualizationTemplate.address, getValue: (result) => result.raw_data?.contact_info?.address, icon: "📍" },
        ]},
        { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => { const s = result.source; if (!s) return null; return { ...s, keyword: s.keyword, scraped_url: s.scraped_url }; } },
        { type: "meta", label: t.visualizationTemplate.details, items: [
          { key: "url", label: t.visualizationTemplate.pageUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
          { key: "scraped_url", label: t.visualizationTemplate.foundVia, getValue: (result) => result.source?.scraped_url, isLink: true, icon: "🔍" },
          { key: "keyword", label: t.visualizationTemplate.keyword, getValue: (result) => result.source?.keyword, icon: "🔑" },
          { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
        ]}
      ]
    },

    // Внутри getVisualizationTemplates, перед default:
instagram_reels: {
  title: t.visualizationTemplate.instagramReel || "Instagram Reel",
  aiVariables: [
    { key: "USERNAME", label: t.visualizationTemplate.usernameInstagramPost, getValue: (result) => result.raw_data?.profile_info?.username || result.raw_data?.username || "N/A" },
    { key: "TEXT", label: t.visualizationTemplate.textInstagramPost, getValue: (result) => result.raw_data?.text || "N/A" },
    { key: "VIDEO", label: t.visualizationTemplate.videoUrl || "Video URL", getValue: (result) => result.raw_data?.video_url || result.raw_data?.url || "N/A" },
    { key: "LIKES", label: t.visualizationTemplate.likes, getValue: (result) => String(result.raw_data?.likes || 0) },
    { key: "COMMENTS", label: t.visualizationTemplate.comments, getValue: (result) => String(result.raw_data?.comments || 0) },
    { key: "VIEWS", label: t.visualizationTemplate.views || "Views", getValue: (result) => String(result.raw_data?.views || 0) },
  ],
  basicFilters: [
    { key: "USERNAME", label: t.visualizationTemplate.usernameInstagramPost, type: "text" },
    { key: "TEXT", label: t.visualizationTemplate.textInstagramPost, type: "text" },
    { key: "LIKES", label: t.visualizationTemplate.likes, type: "number" },
    { key: "COMMENTS", label: t.visualizationTemplate.comments, type: "number" },
    { key: "VIEWS", label: t.visualizationTemplate.views || "Views", type: "number" },
  ],
  sections: [

    { type: "text", key: "text", label: t.visualizationTemplate.caption, getValue: (result) => result.raw_data?.text, style: { fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap", maxHeight: 300, overflowY: "auto" } },
    { type: "video", key: "video_url", label: t.visualizationTemplate.video || "Video", getValue: (result) => result.raw_data?.video_url || result.url, style: { maxHeight: 400, borderRadius: 12, background: "#000" } },
    { type: "stats", label: t.visualizationTemplate.engagement, items: [
      { key: "likes", label: t.visualizationTemplate.likes, getValue: (result) => result.raw_data?.likes?.toLocaleString() || "0", icon: "❤️" },
      { key: "comments", label: t.visualizationTemplate.comments, getValue: (result) => result.raw_data?.comments?.toLocaleString() || "0", icon: "💬" },
      { key: "views", label: t.visualizationTemplate.views || "Views", getValue: (result) => result.raw_data?.views?.toLocaleString() || "0", icon: "👁" },
    ]},
    { type: "author_link", label: t.visualizationTemplate.author, getValue: (result) => {
      const username = result.raw_data?.profile_info?.username || result.raw_data?.username;
      if (!username) return null;
      return { username: `@${username}`, url: `https://instagram.com/${username}`, icon: "👤" };
    }},
    { type: "source", label: t.visualizationTemplate.foundVia, getValue: (result) => result.source },
    { type: "meta", label: t.visualizationTemplate.postInfo, items: [
      { key: "url", label: t.visualizationTemplate.postUrl, getValue: (result) => result.url, isLink: true, icon: "🔗" },
      { key: "created_at", label: t.visualizationTemplate.scraped, getValue: (result) => formatDate(result.created_at), icon: "📅" },
    ]}
  ]
},



 instagram_adb: {
  title: 'Instagram ADB',
  aiVariables: [
    { key: "COUNTRY", label: "Country", getValue: (result) => result.raw_data?.country || "N/A" },
    { key: "USERNAME", label: "Username", getValue: (result) => result.raw_data?.username || "N/A" },
    { key: "FULL_NAME", label: "Full Name", getValue: (result) => result.raw_data?.full_name || "N/A" },
    { key: "BIO", label: "Bio", getValue: (result) => result.raw_data?.bio || "N/A" },
    { key: "EMAIL", label: "Email", getValue: (result) => result.raw_data?.email || "N/A" },
    { key: "FOLLOWERS", label: "Followers", getValue: (result) => String(result.raw_data?.followers || "0") },
    { key: "FOLLOWING", label: "Following", getValue: (result) => String(result.raw_data?.following || "0") },
    { key: "MEDIACOUNT", label: "Posts", getValue: (result) => String(result.raw_data?.mediacount || "0") },
    { key: "LINKS", label: "Links", getValue: (result) => {
      const links = result.raw_data?.links;
      return Array.isArray(links) ? links.join(', ') : "N/A";
    }},
    { key: "SCREENSHOT", label: "Screenshot", getValue: (result) => result.raw_data?.screenshot_url || "N/A" },
  ],

  basicFilters: [
    { key: "COUNTRY", label: "Country", type: "text" },
    { key: "USERNAME", label: "Username", type: "text" },
    { key: "FULL_NAME", label: "Full Name", type: "text" },
    { key: "BIO", label: "Bio", type: "text" },
    { key: "EMAIL", label: "Email", type: "text" },
    { key: "FOLLOWERS", label: "Followers", type: "number" },
    { key: "FOLLOWING", label: "Following", type: "number" },
    { key: "MEDIACOUNT", label: "Posts", type: "number" },
    { key: "HAS_EMAIL", label: "Has Email", type: "bool" },
    { key: "HAS_LINKS", label: "Has Links", type: "bool" },
    { key: "HAS_SCREENSHOT", label: "Has Screenshot", type: "bool" },

    {
      key: "LAST_POST_DATE",
      label: "Last post date",   // we'll add this translation key
      type: "date"
    },
  ],

  sections: [
    // Profile Header
   

    { 
      type: "profile_header", 
      label: "Profile", 
      getValue: (result) => {
        const username = result.raw_data?.username;
        if (!username) return null;
        return {
          username: `${username}`,
          url: `https://instagram.com/${username}`,
          full_name: result.raw_data?.full_name,
          profile_pic_url: null
        };
      }
    },
    
    // Bio
    { 
      type: "text", 
      key: "bio", 
      label: 'Bio', 
      getValue: (result) => result.raw_data?.bio, 
      style: { 
        fontSize: 14, 
        lineHeight: 1.7, 
        whiteSpace: "pre-wrap", 
        maxHeight: 300, 
        overflowY: "auto" 
      } 
    },
    
    // Email
    { 
      type: "text", 
      key: "email", 
      label: 'Email', 
      getValue: (result) => {
        const email = result.raw_data?.email;
        return email || null;
      },
      style: { 
        fontSize: 14, 
        lineHeight: 1.7 
      } 
    },
    
    // Links - ВСЕ ССЫЛКИ В СТОЛБИК (кликабельные)
    {
      type: "custom",
      key: "links",
      label: 'Links',
      render: (result) => {
        const links = result.raw_data?.links;
        
        // Проверяем, что links существует и это массив
        if (!Array.isArray(links) || links.length === 0) {
          return (
            <div style={{ fontSize: 14, color: '#999' }}>
              No links available
            </div>
          );
        }
        
        // Показываем ВСЕ ссылки в столбик
        return (
          <div style={{
            fontSize: 14,
            lineHeight: 1.7,
            maxHeight: 300,
            overflowY: "auto"
          }}>
            {links.map((link, index) => {
              // Добавляем https:// если ссылка без протокола
              const href = link.startsWith('http') ? link : `https://${link}`;
              return (
                <div 
                  key={index} 
                  style={{ 
                    marginBottom: 8,
                    padding: '4px 0'
                  }}
                >
                  <a 
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      color: '#1890ff',
                      textDecoration: 'none',
                      wordBreak: 'break-all',
                      display: 'inline-block'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.textDecoration = 'underline';
                      e.target.style.color = '#40a9ff';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.textDecoration = 'none';
                      e.target.style.color = '#1890ff';
                    }}
                  >
                    🔗 {link}
                  </a>
                </div>
              );
            })}
          </div>
        );
      }
    },
    
    {
      type: "custom",
      key: "latest_posts",
      label: 'Latest posts',
      render: (result) => {
        const latest_posts = result.raw_data?.latest_posts;
        
        // Проверяем, что links существует и это массив
        if (!Array.isArray(latest_posts) || latest_posts.length === 0) {
          return (
            <div style={{ fontSize: 14, color: '#999' }}>
              No posts available
            </div>
          );
        }
        
        // Показываем ВСЕ ссылки в столбик
        return (
          <div style={{
            fontSize: 14,
            lineHeight: 1.7,
            maxHeight: 300,
            overflowY: "auto"
          }}>
            {latest_posts.map((post, index) => {
              // Добавляем https:// если ссылка без протокола
              

              return (
                <div 
                  key={index} 
                  style={{ 
                    marginBottom: 8,
                    padding: '4px 0'
                  }}
                >
                  {post}
                </div>
              );
            })}
          </div>
        );
      }
    },

    // Stats
    { 
      type: "stats", 
      label: "Page Stats", 
      items: [
        { 
          key: "followers", 
          label: "Followers", 
          getValue: (result) => result.raw_data?.followers?.toLocaleString() || "0", 
          icon: "👥" 
        },
        { 
          key: "following", 
          label: "Following", 
          getValue: (result) => result.raw_data?.following?.toLocaleString() || "0", 
          icon: "👣" 
        },
        { 
          key: "posts", 
          label: "Posts", 
          getValue: (result) => result.raw_data?.mediacount?.toLocaleString() || "0", 
          icon: "📝" 
        },
      ]
    },
    
    // Country
    { 
      type: "meta", 
      label: "Location", 
      items: [
        { 
          key: "country", 
          label: "Country", 
          getValue: (result) => result.raw_data?.country, 
          icon: "🌍" 
        },
      ]
    },


    
    // Screenshot
    { 
      type: "image", 
      key: "screenshot_url", 
      label: "Screenshot", 
      getValue: (result) => "https://flautreach.com/media/" + result.raw_data?.screenshot_url,
      style: { 
        maxHeight: 500, 
        objectFit: "contain", 
        borderRadius: 12, 
        background: "#f5f5f5" 
      } 
    },
    
    // Meta
    { 
      type: "meta", 
      label: "Details", 
      items: [
        { 
          key: "url", 
          label: "Instagram URL", 
          getValue: (result) => result.url, 
          isLink: true, 
          icon: "🔗" 
        },
        { 
          key: "created_at", 
          label: "Scraped", 
          getValue: (result) => formatDate(result.created_at), 
          icon: "📅" 
        },
      ]
    }




  ]
},

  facebook_screenshot: {
  title: 'Facebook Screenshot',
  aiVariables: [
    { key: "NAME", label: "Page Name", getValue: (result) => result.raw_data?.name || "N/A" },
    { key: "STATUS_TEXT", label: "Status", getValue: (result) => result.raw_data?.status_text || "N/A" },
    { key: "COUNTRY", label: "Country", getValue: (result) => result.raw_data?.country || "N/A" },
    { key: "EMAIL", label: "Email", getValue: (result) => result.raw_data?.email || "N/A" },
    { key: "PHONE", label: "Phone", getValue: (result) => result.raw_data?.phone || "N/A" },
    { key: "WEBSITE", label: "Website", getValue: (result) => result.raw_data?.website || "N/A" },
    { key: "ADDRESS", label: "Address", getValue: (result) => result.raw_data?.address || "N/A" },
    { key: "FOLLOWERS", label: "Followers", getValue: (result) => String(result.raw_data?.followers || "0") },
    { key: "FOLLOWING", label: "Following", getValue: (result) => String(result.raw_data?.following || "0") },
    { key: "RAW_RESPONSE", label: "AI Response", getValue: (result) => result.raw_data?.raw_response || "N/A" },
  ],

  basicFilters: [
    { key: "NAME", label: "Page Name", type: "text" },
    { key: "COUNTRY", label: "Country", type: "text" },
    { key: "EMAIL", label: "Email", type: "text" },
    { key: "PHONE", label: "Phone", type: "text" },
    { key: "WEBSITE", label: "Website", type: "text" },
    { key: "FOLLOWERS", label: "Followers", type: "number" },
    { key: "HAS_EMAIL", label: "Has Email", type: "bool" },
    { key: "HAS_PHONE", label: "Has Phone", type: "bool" },
    { key: "HAS_WEBSITE", label: "Has Website", type: "bool" },
    { key: "IS_FACEBOOK_PAGE", label: "Is Facebook Page", type: "bool" },
  ],

  sections: [
    // Profile Header
 

    { 
      type: "profile_header", 
      label: "Profile", 
      getValue: (result) => {
        const name = result.raw_data?.name;
        if (!name) return null;
        return {
          username: name,
          url: result.url || result.raw_data?.url,
          full_name: name,
          profile_pic_url: result.raw_data?.avatar_url,
          subtitle: result.raw_data?.category || null
        };
      }
    },
    
    // Status Text
    { 
      type: "text", 
      key: "status_text", 
      label: 'Status / Bio', 
      getValue: (result) => result.raw_data?.status_text, 
      style: { 
        fontSize: 14, 
        lineHeight: 1.7, 
        whiteSpace: "pre-wrap", 
        maxHeight: 300, 
        overflowY: "auto" 
      } 
    },
    
    // AI Raw Response
    { 
      type: "text", 
      key: "raw_response", 
      label: 'AI Analysis', 
      getValue: (result) => result.raw_data?.raw_response,
      style: { 
        fontSize: 14, 
        lineHeight: 1.7, 
        whiteSpace: "pre-wrap", 
        maxHeight: 300, 
        overflowY: "auto",
        background: "#f0fdf4"
      } 
    },
    
    // Stats
    { 
      type: "stats", 
      label: "Page Stats", 
      items: [
        { 
          key: "followers", 
          label: "Followers", 
          getValue: (result) => {
            const followers = result.raw_data?.followers;
            return followers ? followers.toLocaleString() : "0";
          }, 
          icon: "👥" 
        },
        { 
          key: "following", 
          label: "Following", 
          getValue: (result) => {
            const following = result.raw_data?.following;
            return following ? following.toLocaleString() : "0";
          }, 
          icon: "👣" 
        },
      ]
    },
    
    // Contact Info
    { 
      type: "meta", 
      label: "Contact Information", 
      items: [
        { 
          key: "email", 
          label: "Email", 
          getValue: (result) => result.raw_data?.email, 
          icon: "✉️" 
        },
        { 
          key: "phone", 
          label: "Phone", 
          getValue: (result) => result.raw_data?.phone, 
          icon: "📞" 
        },
        { 
          key: "website", 
          label: "Website", 
          getValue: (result) => result.raw_data?.website, 
          isLink: true, 
          icon: "🌐" 
        },
        { 
          key: "address", 
          label: "Address", 
          getValue: (result) => result.raw_data?.address, 
          icon: "📍" 
        },
      ]
    },
    
    // Country & Business Info
    { 
      type: "meta", 
      label: "Details", 
      items: [
        { 
          key: "country", 
          label: "Country", 
          getValue: (result) => result.raw_data?.country, 
          icon: "🌍" 
        },
        { 
          key: "business_hours", 
          label: "Business Hours", 
          getValue: (result) => result.raw_data?.business_hours, 
          icon: "🕒" 
        },
        { 
          key: "is_facebook_page", 
          label: "Facebook Page", 
          getValue: (result) => result.raw_data?.is_facebook_page ? "Yes ✅" : "No ❌", 
          icon: "📄" 
        },
      ]
    },
    
    // Source & Meta
    { 
      type: "meta", 
      label: "Post Info", 
      items: [
        { 
          key: "url", 
          label: "Facebook URL", 
          getValue: (result) => result.url, 
          isLink: true, 
          icon: "🔗" 
        },
        { 
          key: "created_at", 
          label: "Scraped", 
          getValue: (result) => formatDate(result.created_at), 
          icon: "📅" 
        },
      ]
    }
  ]
},
  



    default: {
      title: t.visualizationTemplate.result,
      aiVariables: [
        { key: "RAW_DATA", label: t.visualizationTemplate.rawJson, getValue: (result) => JSON.stringify(result, null, 2) },
      ],
      sections: [
        { type: "json", label: t.visualizationTemplate.rawData, getValue: (result) => result }
      ]
    }
  };
}

function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) +
    " " + d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
}

export function getTemplate(subtype, lang) {
  const templates = getVisualizationTemplates(lang);
  return templates[subtype] || templates.default;
}